function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".icon_pending_a{fill:#aec5de;}.icon_pending_b{fill:#3f4448;opacity:0.1;}.icon_pending_c{fill:#fff;}.icon_pending_d{opacity:0.2;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_pending_a",
  d: "M3.541,3.541A11.976,11.976,0,0,0,20.478,20.478a12.032,12.032,0,0,0,0-16.937A11.9,11.9,0,0,0,3.541,3.541Z",
  transform: "translate(0 0)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_pending_b",
  d: "M52.473,35.911a11.809,11.809,0,0,1,1.874,6.445A12.026,12.026,0,0,1,42.356,54.347a11.809,11.809,0,0,1-6.445-1.874A11.994,11.994,0,1,0,52.473,35.911Z",
  transform: "translate(-34.019 -34.019)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_pending_c",
  d: "M122.307,198.271a1.663,1.663,0,0,1-1.649,1.649h-9.143a1.649,1.649,0,0,1,0-3.3h9.068A1.681,1.681,0,0,1,122.307,198.271Z",
  transform: "translate(-104.078 -186.261)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_pending_d",
  transform: "translate(4.051 3.901)"
}, React.createElement("path", {
  className: "icon_pending_c",
  d: "M80.563,77.719c-1.2,1.2-2.773,1.649-3.372.974-.674-.674-.225-2.173.974-3.372s2.773-1.649,3.447-.974C82.211,74.946,81.762,76.52,80.563,77.719Z",
  transform: "translate(-76.876 -74.032)"
}));

var SvgPending = function SvgPending(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pending.6c5533d0.svg";
export { ForwardRef as ReactComponent };